import React, { useEffect, useMemo, useRef, useState } from "react";
import api from "../../services/api";
import { toast } from "react-toastify";
import { getCurrentUser } from "../../services/auth";
import "./modal.css";

export default function TransactionModal({ onClose, onSuccess }) {
  const user = getCurrentUser();

  const storedUser =
    JSON.parse(localStorage.getItem("user")) || {};

  const authUser = storedUser.user
    ? storedUser.user
    : storedUser;

  // const parokiaName =
  // user?.parokiaName || "";

  // console.log("user-->",user)

  const [members, setMembers] = useState([]);
  //const [types, setTypes] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [template, setTemplate] = useState("");
  const [loadingData, setLoadingData] =
    useState(true);

  const [submitting, setSubmitting] =
    useState(false);

  const [memberIdSearch, setMemberIdSearch] =
    useState("");

  const [showMemberDropdown, setShowMemberDropdown] =
    useState(false);

  const [showConfirm, setShowConfirm] =
    useState(false);

  const [smsBalance, setSmsBalance] =
    useState(null);

  const dropdownRef = useRef(null);

  const [form, setForm] = useState({
    memberId: "",
    templateId: "",
    contributionType: "",
    amount: "",
    channel: "CASH",
    referenceNo: "",
    cashierName: "",
    transactionDate: new Date()
      .toISOString()
      .slice(0, 10),

    transactionId: "",
  });

  useEffect(() => {
    loadInitialData();
  }, []);

  useEffect(() => {
    const username =
      authUser?.username ||
      JSON.parse(localStorage.getItem("user"))
        ?.username ||
      "";

    setForm((prev) => ({
      ...prev,
      cashierName: username,
    }));
  }, [authUser?.username]);

  // useEffect(() => {
  //   if (!form.contributionType) {
  //     setTemplate("");
  //     return;
  //   }

  //   fetchTemplate(form.contributionType);
  // }, [form.contributionType]);
  useEffect(() => {
    if (!form.templateId) {
        setTemplate("");
          return;
      }
      fetchTemplate(form.templateId);

      }, [form.templateId]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(
          event.target
        )
      ) {
        setShowMemberDropdown(false);
      }
    };

    document.addEventListener(
      "mousedown",
      handleClickOutside
    );

    return () =>
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
  }, []);

  const loadInitialData = async () => {
    try {
      setLoadingData(true);

      const [membersRes, templatesRes, balanceRes] =
        await Promise.all([
          api.get("/members"),
          // api.get("/contribution-types"),
          api.get("/sms/templates/available"),
          api.get("/sms/balance"),
        ]);

      setSmsBalance(
        balanceRes.data?.balance || 0
      );

      setMembers(
        Array.isArray(membersRes.data)
          ? membersRes.data
          : []
      );

      // setTypes(
      //   Array.isArray(typesRes.data)
      //     ? typesRes.data.filter(
      //         (t) => t.status === "ACTIVE"
      //       )
      //     : []
      // );
      setTemplates(
          Array.isArray(templatesRes.data)
              ? templatesRes.data
              : []
      );
    } catch (err) {
      toast.error(
        "Failed to load members or SMS templates"
      );
    } finally {
      setLoadingData(false);
    }
  };

  const fetchTemplate = async (templateId) => {
    try {
      const res = await api.get(
        // "/sms/template-by-type",
        "/sms/template",
        {
          params: { templateId },
        }
      );

      setTemplate(
        res.data?.message_template || ""
      );
    } catch {
      setTemplate("");
    }
  };

  const filteredMembersById = useMemo(() => {
    const q = memberIdSearch
      .trim()
      .toLowerCase();

    if (!q) return members.slice(0, 10);

    return members.filter((m) =>
      String(m.member_code || "")
        .toLowerCase()
        .includes(q)
    );
  }, [members, memberIdSearch]);

  const selectedMember = useMemo(() => {
    return (
      members.find(
        (m) =>
          Number(m.member_id) ===
          Number(form.memberId)
      ) || null
    );
  }, [members, form.memberId]);

  const selectMember = (member) => {
    setForm((prev) => ({
      ...prev,
      memberId: member.member_id,
    }));

    setMemberIdSearch("");
    setShowMemberDropdown(false);
  };

  const previewMessage = () => {
    if (!selectedMember || !template)
      return "";

    //return template
    const msg = template
      .replace(
        "{NAME}",
        selectedMember.full_name || ""
      )
      .replace(
        "{AMOUNT}",
        form.amount || ""
      )
      .replace(
        "{TYPE}",
        form.contributionType || ""
      )
      .replace(
        "{TRANSACTION_ID}",
        form.transactionId || ""
      )
      .replace(
        "{MEMBER_CODE}",
        selectedMember.member_code || ""
      )
      .replace(
        "{PHONE}",
        selectedMember.phone || ""
      )
      .replace(
        "{DATE}",
        form.transactionDate || ""
      )
      // .replace(
      //   "{PAROKIA}",
      //   parokiaName || ""
      // );
      return `${msg}`;
      // return `${msg}\n\n ${parokiaName}`;
  };

  const confirmSubmit = async () => {
    try {
      setSubmitting(true);

      const payload = {
        memberId: Number(form.memberId),
        templateId:Number(form.templateId),
        contributionType: form.contributionType,
        amount: form.amount,
        channel: form.channel,
        referenceNo: form.referenceNo || null,
        cashierName: user?.username,
        transactionDate: form.transactionDate,
      };

      const response = await api.post(
        "/transactions",
        payload
      );

      const trxId =
        response.data?.transactionId;

      setForm((prev) => ({
        ...prev,
        transactionId: trxId,
      }));

      
     if (
        response.data?.smsStatus === "SENT"
      ) {
        const balanceRes = await api.get(
          "/sms/balance"
        );

        setSmsBalance(
          balanceRes.data?.balance || 0
        );

        toast.success(
          "Transaction posted successfully and SMS sent"
        );
      } else {
        toast.success(
          "Transaction posted successfully"
        );
      }

      setTimeout(() => {
        onSuccess?.();
        onClose?.();
      }, 500);
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          "Transaction failed"
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal transaction-modal">
        <div
          className={`modal-close ${
            submitting ? "disabled" : ""
          }`}
          onClick={() => {
            if (!submitting) {
              onClose();
            }
          }}
        >
          ✕
        </div>

        <h3>Post Transaction</h3>

        {loadingData ? (
          <div className="spinner-wrap">
            <div className="spinner" />
          </div>
        ) : (
          <>
            {submitting && (
              <div className="transaction-processing-overlay">
                <div className="transaction-processing-box">
                  <div className="spinner large" />

                  <div className="processing-title">
                    Processing Transaction...
                  </div>

                  <div className="processing-subtitle">
                    Please wait while
                    transaction is being
                    submitted
                  </div>
                </div>
              </div>
            )}

            <div className="transaction-form-grid">
              <FieldLabel required>
                Member ID
              </FieldLabel>

              <div
                ref={dropdownRef}
                style={{
                  position: "relative",
                }}
              >
                <div className="member-row">
                  <input
                    className="input"
                    placeholder="MemberId - Name"
                    value={
                      selectedMember
                        ? `${selectedMember.member_code} - ${selectedMember.full_name}`
                        : ""
                    }
                    readOnly
                  />

                  <input
                    className="input"
                    placeholder="Search by Member ID"
                    value={memberIdSearch}
                    onChange={(e) => {
                      setMemberIdSearch(
                        e.target.value
                      );

                      setShowMemberDropdown(
                        true
                      );
                    }}
                    onFocus={() =>
                      setShowMemberDropdown(
                        true
                      )
                    }
                  />
                </div>

                {showMemberDropdown && (
                  <div className="dropdown">
                    {filteredMembersById.length ===
                    0 ? (
                      <div className="dropdown-item">
                        No members found
                      </div>
                    ) : (
                      filteredMembersById.map(
                        (m) => (
                          <div
                            key={m.member_id}
                            className="dropdown-item"
                            onClick={() =>
                              selectMember(m)
                            }
                          >
                            {m.member_code} -{" "}
                            {m.full_name}
                          </div>
                        )
                      )
                    )}
                  </div>
                )}
              </div>

              <FieldLabel>
                Jumuiya Name
              </FieldLabel>

              <input
                className="input"
                value={
                  selectedMember?.jumuia_name ||
                  ""
                }
                readOnly
              />

              <FieldLabel>
                Mobile Number
              </FieldLabel>

              <input
                className="input"
                value={
                  selectedMember?.phone || ""
                }
                readOnly
              />

              <FieldLabel required>
                Transaction Type
              </FieldLabel>

              {/* <select
                className="input"
                value={
                  form.contributionType
                }
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    contributionType:
                      e.target.value,
                  }))
                }
              >
                <option value="">
                  --Transaction Type--
                </option>

                {types.map((t) => (
                  <option
                    key={t.type_id}
                    value={t.name}
                  >
                    {t.name}
                  </option>
                ))}
              </select> */}
                <select
                  className="input"
                  value={form.templateId}
                onChange={(e) => {

                const id = Number(e.target.value);

                const selected = templates.find(
                    t => Number(t.template_id) === id
                );

                if (!selected) {

                    setForm(prev => ({
                        ...prev,
                        templateId: "",
                        contributionType: ""
                    }));

                    return;
                }

                setForm(prev => ({
                    ...prev,
                    templateId: selected.template_id,
                    contributionType: selected.contribution_type
                }));

            }}
                >

                  <option value="">
                    -- Select SMS Template --
                  </option>
                  {
                    templates.map(t => (
                      <option
                        key={t.template_id}
                        value={t.template_id}
                      >
                        {
                          t.parokia_id === null ? `${t.contribution_type} (Default)` : `${t.contribution_type}`
                        }
                      </option>
                    ))
                  }
                </select>

              <FieldLabel required>
                Payment Type
              </FieldLabel>

              <select
                className="input"
                value={form.channel}
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    channel: e.target.value,
                  }))
                }
              >
                <option value="CASH">
                  CASH
                </option>

                <option value="BANK">
                  BANK
                </option>
              </select>

              <FieldLabel required>
                Amount
              </FieldLabel>

              <input
                type="number"
                className="input"
                value={form.amount}
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    amount: e.target.value,
                  }))
                }
              />

              {form.channel === "BANK" && (
                <>
                  <FieldLabel>
                    Reference No
                  </FieldLabel>

                  <input
                    className="input"
                    value={
                      form.referenceNo
                    }
                    onChange={(e) =>
                      setForm((prev) => ({
                        ...prev,
                        referenceNo:
                          e.target.value,
                      }))
                    }
                  />
                </>
              )}

              <FieldLabel>Date</FieldLabel>

              <input
                type="date"
                className="input"
                value={
                  form.transactionDate
                }
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    transactionDate:
                      e.target.value,
                  }))
                }
              />

              <FieldLabel>
                Cashier
              </FieldLabel>

              <input
                className="input"
                value={
                  user?.username || ""
                }
                readOnly
              />

              {template && (
                <>
                  <FieldLabel>
                    SMS Preview
                  </FieldLabel>

                  <div className="sms-preview">
                    {previewMessage()}
                  </div>
                </>
              )}
            </div>

            <div className="modal-actions">
              <button
                className="btn light"
                disabled={submitting}
                onClick={() => {
                  if (!submitting) {
                    onClose();
                  }
                }}
              >
                Close
              </button>

              {smsBalance <= 0 && (
                <div
                  style={{
                    color: "red",
                    fontWeight: 600,
                    marginBottom: 10,
                  }}
                >
                  SMS balance exhausted.
                  Please subscribe to
                  continue posting
                  transactions.
                </div>
              )}

              <button
                className="btn primary"
                disabled={
                  submitting ||
                  smsBalance <= 0
                }
                onClick={() => {
                  if (
                    !form.memberId ||
                    !form.templateId ||
                    !form.amount 
                  
                  ) {
                    toast.error(
                      "Please fill required fields"
                    );

                    return;
                  }

                  setShowConfirm(true);
                }}
              >
                {submitting ? (
                  <div className="btn-loader-wrap">
                    <div className="btn-spinner" />

                    <span>
                      Processing...
                    </span>
                  </div>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </>
        )}
      </div>

      {showConfirm && (
        <div className="confirm-overlay">
          <div className="confirm-box">
            <h4>Confirm Request</h4>

            <p>
              Are you sure you want to
              submit transaction of
              amount{" "}
              <strong>
                {Number(
                  form.amount
                ).toLocaleString()}
              </strong>
              ?
            </p>

            <div className="confirm-actions">
              <button
                className="btn light"
                onClick={() =>
                  setShowConfirm(false)
                }
              >
                No
              </button>

              <button
                className="btn primary"
                onClick={() => {
                  setShowConfirm(false);

                  confirmSubmit();
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function FieldLabel({
  children,
  required = false,
}) {
  return (
    <label
      style={{
        fontWeight: 600,
        fontSize: 13,
      }}
    >
      {children}{" "}
      {required && (
        <span style={{ color: "red" }}>
          *
        </span>
      )}
    </label>
  );
}